// extracted by mini-css-extract-plugin
export default {"Main":"Main_ih8eo","Main_article":"Main_article_O8xmM"};